
export const Theme = {
  container: 'relative',
  containerDragging: 'shadow-md cursor-grabbing z-10'
}
